var exports = {
  "Z": "xaee3c4fa--e5970e--legal-check-wrapper",
};

module.exports = exports;
